import { VisitSettlementAdjustment } from '@dreryk/egabinet-financial-settlement-frontend-api';
import { Money } from '@dreryk/money-common-api';

import { getCustomFormattingContext, priceFormatter } from '@dreryk/react-common';
import { StyledFlex, StyledMargin } from '@dreryk/react-components';

import { AdjustmentDataText } from '../../../../shared/adjustment/AdjustmentDataText';
import { TotalPriceText } from '../../../../shared/medicalServices/MedicalServicesTotalPriceText';

type MedicalServicesTableFooterProps = {
   readonly totalPrice: Money;
   readonly adjustmentBy?: VisitSettlementAdjustment;
};

export const MedicalServicesTableFooter = (props: MedicalServicesTableFooterProps): JSX.Element => {
   return (
      <StyledMargin top={8} right={8}>
         <StyledFlex justifyContent={'space-between'}>
            {props.adjustmentBy ? (
               <StyledFlex>
                  <AdjustmentDataText
                     author={`${props.adjustmentBy?.adjustedBy.firstName} ${props.adjustmentBy?.adjustedBy.lastName}`}
                     date={props.adjustmentBy.adjustmentDate}
                  />
               </StyledFlex>
            ) : null}
            <StyledFlex justifyContent={'end'} flex={'1'}>
               <TotalPriceText
                  totalPrice={priceFormatter(
                     props.totalPrice.asNumber(),
                     getCustomFormattingContext({
                        options: { currency: 'PLN', stripDecimalZeroes: true },
                     })
                  )}
               />
            </StyledFlex>
         </StyledFlex>
      </StyledMargin>
   );
};
